/**
 * Additive multilingual layer (de/it/he/es/fr/pl/nl).
 * The existing English and Romanian pages are NOT part of this system and keep
 * their current URLs, copy and metadata.
 */

export const LOCALE_CODES = ["de", "it", "he", "es", "fr", "pl", "nl"] as const;
export type LocaleCode = (typeof LOCALE_CODES)[number];

export const PAGE_KEYS = [
  "country",
  "airport-otopeni",
  "airport-cluj",
  "airport-iasi",
  "airport-timisoara",
  "airport-sibiu",
  "city-bucharest",
  "city-brasov",
  "city-cluj",
  "city-constanta",
  "cheap",
  "automatic",
  "unlimited-km",
  "one-way",
  "seven-seater",
  "guide-transfagarasan",
  "guide-transylvania",
  "guide-black-sea",
  "rules-rovinieta",
  "rules-winter-tires",
  "rules-speed-cameras",
  "airport-pickup",
] as const;
export type PageKey = (typeof PAGE_KEYS)[number];

export interface Faq {
  q: string;
  a: string;
}

export interface Section {
  h2: string;
  body: string[];
}

export interface PageCopy {
  /** URL segment after /{locale}/ — localized, no leading slash. Empty for the country hub. */
  slug: string;
  title: string;
  description: string;
  eyebrow: string;
  h1: string;
  intro: string;
  /** 4 short trust/perk cards shown under the hero. */
  perks: { title: string; text: string }[];
  sections: Section[];
  faqs: Faq[];
  keywords?: string;
}

export interface LocaleUi {
  label: string;
  /** Nav labels for the in-locale page links. */
  nav: { country: string; airports: string; cities: string; guides: string };
  bookCta: string;
  fleetCta: string;
  whatsappCta: string;
  fleetTitle: string;
  fleetSubtitle: string;
  faqTitle: string;
  mapTitle: string;
  relatedTitle: string;
  priceNote: string;
  breadcrumbHome: string;
}

export interface LocalePack {
  code: LocaleCode;
  htmlLang: string;
  dir: "ltr" | "rtl";
  ui: LocaleUi;
  pages: Record<PageKey, PageCopy>;
}
